import React, { useState, useCallback, useRef } from "react";
import { Controller } from "react-hook-form";
import AsyncSelect from "react-select/async";
import { Col } from "react-bootstrap";
import { GetMorphologyCodeDescription } from "../config/preauthorizationApi";
import { useDispatch } from "react-redux";

const DiagnosisMorphologySelect = ({ control, setValue, watch, required, disabled }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const debounceTimeout = useRef(null);

  const loadOptions = useCallback(
    (inputValue, callback) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      if (!inputValue) {
        callback([]);
        return;
      }

      debounceTimeout.current = setTimeout(async () => {
        try {
          setLoading(true);
          const response = await dispatch(
            GetMorphologyCodeDescription({ morph_code: inputValue })
          ).unwrap();

          const options =
            response.data?.Morphology_Code?.map((item) => ({
              value: item.morphology_code,
              label: item.morphology_shdescription,
            })) || [];

          callback(options);
        } catch (error) {
          console.error("Error fetching morphology codes:", error);
          callback([]);
        } finally {
          setLoading(false);
        }
      }, 500);
    },
    [dispatch]
  );

  return (
    <>
      <Controller
        name="diagnosis_morphology"
        control={control}
        rules={{ required: required }}
        render={({ field }) => (
          <AsyncSelect
            {...field}
            isClearable
            defaultOptions
            loadOptions={loadOptions}
            size="sm"
            isDisabled={disabled}
            isLoading={loading}
            placeholder="Search morphology codes..."
            classNamePrefix="react-select"
            menuPlacement="auto"
            value={
              field.value
                ? {
                  value: field.value.morphology_code,
                  label: field.value.morphology_shdescription,
                }
                : null
            }
            onChange={(selected) => {
              setValue(
                "diagnosis_morphology",
                selected
                  ? {
                    morphology_code: selected.value,
                    morphology_shdescription: selected.label,
                  }
                  : null
              );
            }}
            styles={customSmStyles}
            formatOptionLabel={({ value, label }) => (
              <div>
                {" "}
                ({value}) {label}
              </div>
            )}
          />
        )}
      />
    </>
  );
};

export default DiagnosisMorphologySelect;

// === Styles ===
const customSmStyles = {
  control: (base) => ({
    ...base,
    minHeight: "29px",
    fontSize: "0.875rem",
    backgroundColor: "var(--falcon-input-bg)",
    borderColor: "var(--falcon-input-border-color)",
    "&:hover": {
      borderColor: "var(--falcon-input-focus-border-color)",
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
    color: "var(--falcon-input-color)",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    color: "var(--falcon-input-color) !important",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "29px",
    minHeight: "29px",
    svg: {
      color: "var(--falcon-input-color) !important",
    },
  }),
  option: (base, { isFocused, isSelected }) => ({
    ...base,
    paddingTop: 8,
    paddingBottom: 0,
    paddingLeft: 10,
    paddingRight: 10,
    fontSize: "0.8rem",
    minHeight: "30px",
    lineHeight: "1.2",
  }),
  menu: (base) => ({
    ...base,
    marginTop: 0,
    borderRadius: 0,
    backgroundColor: "var(--falcon-card-bg)",
    border: "1px solid var(--falcon-border-color)",
  }),
  menuList: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#fff",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "var(--falcon-body-color)",
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "var(--falcon-body-color)",
    "&:hover": {
      backgroundColor: "var(--falcon-danger)",
      color: "var(--falcon-white)",
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: "var(--falcon-input-placeholder-color)",
    margin: 0,
    padding: 0,
  }),
};
